export default "__VITE_ASSET__mLZw0Tsl__"